/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import {
    Card, CardBody, CardHeader,
    Container, Media,
    Row, Table,
} from "reactstrap";
import Header from "../../components/Headers/Header.js";
import OutstandingMakeups from "./OutstandingMakeups";
import FailedPayments from "./FailedPayments";
import UnmatchedPayments from "./UnmatchedPayments";
import AudioPlayer from "react-h5-audio-player";
import { CopyToClipboard } from "react-copy-to-clipboard";
import moment from "moment/moment";
import { axiosGet, axiosPost } from "../../util/apiConfig";
import { Device } from "@twilio/voice-sdk";

const USER_STATE = {
    CONNECTING: "Connecting",
    READY: "Ready",
    ON_CALL: "On call",
    OFFLINE: "Offline",
}


class Listing extends React.Component {
    constructor(props) {
        super(props);
        this.state = { classId: localStorage.getItem("classId") || null }
    }

    componentDidMount() {
        const classId = localStorage.getItem("classId");
        this.setState(
            {
                allSessionData: [],
                allCounts: [],
                voiceMessageList: [],
                userState: USER_STATE.OFFLINE,
                notificationCallModal: false,
                messageStates: {},
                classId: classId ? classId : null,
                activeCard: "active",
            },
            () => {
                this.getVoiceMessage();
            }
        );
    }

    getVoiceMessage = () => {
        const { activeCard } = this.state;
        // API --
        axiosGet(`sales/get-sales-followup-voice-message?status=${activeCard}`)
            .then((response) => {
                if (!response.isError) {
                    const sanitizedList = (response.data || []).map((item) => {
                        if (item.mobile) {
                            return {
                                ...item,
                                mobile: item.mobile.replace(/^(\+1)+/, '+1'),
                            };
                        }
                        return item;
                    });
                    this.setState({
                        voiceMessageList: sanitizedList,
                    });
                } else {
                    this.setState({
                        voiceMessageList: [],
                    });
                }
            })
            .catch((error) => {
                this.setState({
                    voiceMessageList: [],
                });
            });
    };

    clientConnect = (index) => {
        let { voiceMessageList } = this.state;
        let selectedNotification = voiceMessageList[index];
        this.setState({
            notificationCallModal: true,
            selectedNumber: selectedNotification.mobile || '',
            selectedClassId: selectedNotification.classId || ''
        });
    };

    rejectCall = () => {
        const { device, selectedNumber } = this.state
        device.emit("disconnect");
        device.emit("cancel");
        device.emit("reject");
        device.disconnectAll({ params: { To: selectedNumber } });
    }

    handleCall = async (sale, index) => {
        const confirm = window.confirm(`Are you sure want to call? \nPlease verify details,\nMobile: ${sale.mobile}, `)
        if (!confirm) {
            return false;
        }
        const { device, userType } = this.state;
        device.emit("connect");
        device.connect({ params: { To: sale.mobile, userType, classId: sale.classId } }).then((call) => {
            call.on("accept", () => {
                this.updateMessageState(index, USER_STATE.ON_CALL);
                console.log("call accepted");
            });
            call.on("disconnect", () => {
                console.log("The call has been disconnected.");
                this.updateMessageState(index, USER_STATE.READY);
            });
            call.on("reject", () => {
                console.log("The call was rejected.");
            });
            call.on("cancel", () => {
                console.log("The call was rejected.");
                this.updateMessageState(index, USER_STATE.READY);
            });
        })
    };

    callInit = (sale, index) => {
        axiosPost('sales/token', {})
            .then((response) => {
                if (!response.isError) {
                    this.setState(
                        {
                            loading: false
                        },
                        () => {
                            const token = response.data.token;
                            const device = new Device(token, {
                                logLevel: 1,
                                codecPreferences: ["opus", "pcmu"],
                            });
                            device.register();
                            this.setState({ device })
                            device.addListener("connect", (device) => {
                                console.log("Connect event listener added .....");
                                return device;
                            });
                            device.on("registered", () => {
                                console.log("Agent registered");
                                this.setState({ userState: USER_STATE.READY });
                            });
                            device.on("connect", (connection) => {
                                console.log("Call connect");
                                this.setState({ userState: USER_STATE.ON_CALL })
                            });
                            device.on("disconnect", () => {
                                console.log("Disconnect event");
                                this.setState({ userState: USER_STATE.READY })
                            });

                            setTimeout(() => {
                                this.handleCall(sale, index)
                            }, 1000)

                            return () => {
                                device.destroy();
                                this.setState({ device: undefined })
                                this.setState({ userState: USER_STATE.OFFLINE })
                            };
                        }
                    );
                } else {
                    this.setState({
                        loading: false,
                        errorModal: true,
                        modalTitle: 'Sorry!',
                        message: 'Something is wrong. Try again later.',
                    });
                }
            })
            .catch((error) => {
                this.setState({
                    loading: false,
                    errorModal: true,
                    modalTitle: 'Sorry!',
                    message: 'Something is wrong. Try again later.',
                });
                console.log(error);
            });
    }

    updateMessageState = (index, newState) => {
        this.setState(prevState => ({
            messageStates: {
                ...prevState.messageStates,
                [index]: newState
            }
        }));
    };

    render() {
        let {
            voiceMessageList,
            activeCard,
        } = this.state;

        return (
            <>
                <Header />
                {/* Page content */}
                {/*Create two box in row*/}
                <Container fluid>
                    <Row>
                        <div className="col-lg-6 col-md-12 mb-4">
                            <Card className='shadow border-0' style={{ borderRadius: '12px', overflow: 'hidden' }}>
                                <CardHeader className='border-0 bg-transparent py-4'>
                                    <h3 className='mb-0' style={{ fontWeight: '700', color: '#32325d' }}>
                                        <i className="fa fa-phone-alt mr-2 text-success" style={{ fontSize: '1.2rem' }}></i> Calls
                                    </h3>
                                </CardHeader>
                                    <div className="col-md-4 text-center" style={{ float: "left", paddingBottom: '20px' }}>
                                        <ul className="nav nav-pills" >
                                            <li style={{ cursor: "pointer" }} className="nav-item">
                                                <a
                                                    className={`nav-link ${activeCard == "active" ? "active" : ""
                                                        }`}
                                                    onClick={() => {
                                                        this.setState(
                                                            { activeCard: "active", page: 1 },
                                                            () => {
                                                                this.getVoiceMessage();
                                                            }
                                                        );
                                                    }}
                                                >
                                                    Incoming
                                                </a>
                                            </li>
                                            <li style={{ cursor: "pointer" }} className="nav-item">
                                                <a
                                                    className={`nav-link ${activeCard == "inactive" ? "active" : ""
                                                        }`}
                                                    onClick={() => {
                                                        this.setState(
                                                            { activeCard: "inactive", page: 1 },
                                                            () => {
                                                                this.getVoiceMessage();
                                                            }
                                                        );
                                                    }}
                                                >
                                                    Outgoing
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <CardBody>
                                        <Table
                                            className='align-items-center table-flush cp;'
                                            responsive
                                            style={{ marginBottom: '100px', height: '500px', overflowY: 'scroll', display: 'block' }}
                                        >
                                            <thead className='thead-light'>
                                                <tr>
                                                    <th scope='col'></th>
                                                    <th scope='col'>Name</th>
                                                    <th scope='col'>Mobile Number</th>
                                                    <th scope='col'>Time</th>
                                                    <th scope='col'>Audio</th>
                                                    <th scope='col'>Link</th>
                                                    <th scope='col'>Status</th>
 
                                                    {/*<th scope='col'>Notification Sent</th>*/}
                                                    <th scope='col' />
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {voiceMessageList &&
                                                    voiceMessageList.map((value, index) => {
                                                        const isActive = Object.values(this.state.messageStates).some(
                                                            state => state === 'Connecting' || state === 'On call'
                                                        )
                                                        const userStateForMessage = this.state.messageStates[index] || USER_STATE.OFFLINE;
                                                        const isMissed = value.callStatus && (
                                                            value.callStatus.toLowerCase().includes('missed') ||
                                                            value.callStatus.toLowerCase().includes('no-answer') ||
                                                            value.callStatus.toLowerCase().includes('busy') ||
                                                            value.callStatus.toLowerCase().includes('failed')
                                                        );
                                                        return (
                                                            value.isActive && (
                                                                <tr key={index} className={isMissed ? 'text-danger font-weight-bold' : ''} style={isMissed ? { color: '#f5365c', backgroundColor: '#fff5f5' } : {}}>
                                                                    <td className={`table-column-width ${isMissed ? 'text-danger font-weight-bold' : ''}`} style={isMissed ? { color: '#f5365c' } : {}} >
                                                                        {
                                                                            (userStateForMessage === 'Connecting' || userStateForMessage === 'On call') ? (
                                                                                <button
                                                                                    className={'btn btn-danger'}
                                                                                    onClick={() => this.rejectCall(value.mobile)}
                                                                                >Reject
                                                                                </button>
                                                                            ) : (
                                                                                <button
                                                                                    className={'btn btn-white'}
                                                                                    disabled={isActive}
                                                                                    onClick={() => this.callInit(value, index)}
                                                                                ><i className="fa fa-phone" style={isMissed ? { fontSize: '20px', color: '#f5365c' } : { fontSize: '20px' }} ></i>
                                                                                </button>
                                                                            )
                                                                        }
                                                                        <button onClick={() => this.clientConnect(index)} className={'btn btn-white'}>
                                                                            <i className="fa fa-comments" style={isMissed ? { fontSize: '20px', color: '#f5365c' } : { fontSize: '20px' }} aria-hidden="true" ></i>
                                                                        </button>
                                                                    </td>
                                                                    <td className={`table-column-width ${isMissed ? 'text-danger font-weight-bold' : ''}`} style={isMissed ? { color: '#f5365c' } : {}}>
                                                                        {value.name || 'Unknown'}
                                                                    </td>
                                                                    <td className={`table-column-width ${isMissed ? 'text-danger font-weight-bold' : ''}`} style={isMissed ? { color: '#f5365c' } : {}}>
                                                                        {value.mobile && (
                                                                            <a href={"tel:" + value.mobile} className={isMissed ? 'text-danger font-weight-bold' : ''} style={isMissed ? { color: '#f5365c' } : {}}>{value.mobile}</a>
                                                                        )}{" "}
                                                                    </td>
                                                                    <td className={`table-column-width ${isMissed ? 'text-danger font-weight-bold' : ''}`} style={isMissed ? { color: '#f5365c' } : {}}>
                                                                        <Media className='align-items-center'>
                                                                            <Media>
                                                                                <span className={`mb-0 text-sm ${isMissed ? 'text-danger font-weight-bold' : ''}`} style={isMissed ? { color: '#f5365c' } : {}}>
                                                                                    {value.createdAt
                                                                                        ? moment(value.createdAt).format('ll hh:mm A')
                                                                                        : ''}
                                                                                </span>
                                                                            </Media>
                                                                        </Media>
                                                                    </td>
                                                                    <td className={`table-column-width ${isMissed ? 'text-danger font-weight-bold' : ''}`} style={isMissed ? { color: '#f5365c' } : {}}>
                                                                        {
                                                                            value.fileName ? (
                                                                                <AudioPlayer
                                                                                    autoPlay={false}
                                                                                    autoPlayAfterSrcChange={false}
                                                                                    src={value.fileName}
                                                                                    onPlay={e => console.log("onPlay")}
                                                                                // other props here
                                                                                />
                                                                            ) : (
                                                                                <></>
                                                                            )
                                                                        }
                                                                    </td>
                                                                    <td className={`table-column-width ${isMissed ? 'text-danger font-weight-bold' : ''}`} style={isMissed ? { color: '#f5365c' } : {}}>
                                                                        {
                                                                            value.fileName ? (
                                                                                <CopyToClipboard text={value.fileName}>
                                                                                    <i
                                                                                        style={isMissed ? { cursor: 'pointer', color: '#f5365c' } : { cursor: 'pointer' }}
                                                                                        className='BtnFill'
                                                                                        color={isMissed ? 'danger' : 'success'}
                                                                                    ><i className={`fa fa-copy ${isMissed ? 'text-danger' : ''}`} style={isMissed ? { color: '#f5365c' } : {}}></i>
                                                                                    </i>
                                                                                </CopyToClipboard>
                                                                            ) : (
                                                                                <></>
                                                                            )
                                                                        }
                                                                    </td>
                                                                    <td className={`table-column-width ${isMissed ? 'text-danger font-weight-bold' : ''}`} style={isMissed ? { color: '#f5365c' } : {}}>
                                                                        {value.callStatus && (
                                                                            <span className={isMissed ? 'text-danger font-weight-bold' : ''} style={isMissed ? { color: '#f5365c' } : {}}>
                                                                                {isMissed && <i className="fa fa-phone-slash mr-1" style={{ fontSize: '0.85rem', color: '#f5365c' }}></i>}
                                                                                {value.callStatus}
                                                                            </span>
                                                                        )}{" "}
                                                                    </td>

                                                                </tr>
                                                            )
                                                        );
                                                    })}
                                            </tbody>
                                        </Table>
                                    </CardBody>
                                </Card>
                        </div>
                        <div className="col-lg-6 col-md-12 mb-4">
                            <OutstandingMakeups classId={this.state.classId} />
                        </div>
                    </Row>
                    <hr className='my-10' style={{ border: ' 1px solid #e9ecef' }} />
                    <Row style={{ marginTop: '20px' }}>
                        <div className="col-lg-6 col-md-12 mb-4">
                            <UnmatchedPayments />
                        </div>
                        <div className="col-lg-6 col-md-12 mb-4">
                            <FailedPayments />
                        </div>
                    </Row>
                </Container>
            </>
        );
    }
}

export default Listing;
